import React, { useState } from 'react';
import { toast } from 'sonner';
import { PageHeader } from '../components/common/PageHeader';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Label } from '../components/ui/Label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/Select';
import { cn } from '../utils/cn';
const toggles = [{
  id: 'push',
  label: 'Push-уведомления водителям',
  description: 'Отправлять адрес подачи и телефон клиента при назначении'
}, {
  id: 'sms',
  label: 'SMS клиенту',
  description: 'Сообщать номер автомобиля и время подачи'
}, {
  id: 'auto',
  label: 'Автоназначение заказов',
  description: 'Назначать ближайшего свободного водителя автоматически'
}, {
  id: 'sound',
  label: 'Звук новых заказов',
  description: 'Сигнал в панели оператора при поступлении заказа'
}];
export function Settings() {
  const [enabled, setEnabled] = useState<Record<string, boolean>>({
    push: true,
    sms: true,
    auto: false,
    sound: true
  });
  const [company, setCompany] = useState('ХО «Ашгабат Такси»');
  const [phone, setPhone] = useState('+993 12 45-67-89');
  const [commission, setCommission] = useState('15');
  return <div className="max-w-4xl" data-id="element-488" data-mp="3t6cchpb5ajtw">
      <PageHeader title="Настройки" description="Параметры компании, тарифов и уведомлений" data-id="element-489" data-mp="3t5aybbyu1h7y" />

      <div className="space-y-4" data-id="element-490" data-mp="arlakgeopuy2">
        <Card data-id="element-491" data-mp="aupkzviqtmx6">
          <CardHeader data-id="element-492" data-mp="5u1tz9uil62y">
            <CardTitle className="text-base" data-id="element-493" data-mp="5ul07tasy615">Данные компании</CardTitle>
            <CardDescription data-id="element-494" data-mp="kr2easadlyre">Отображаются в чеках и уведомлениях клиентам</CardDescription>
          </CardHeader>
          <CardContent className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-495" data-mp="frfzieewgagh">
            <div className="space-y-1.5" data-id="element-496" data-mp="fq4rg2ef8gjk">
              <Label htmlFor="company" data-id="element-497" data-mp="2mjgr5cy2cd0y">Название компании</Label>
              <Input id="company" value={company} onChange={e => setCompany(e.target.value)} data-id="element-498" data-mp="2hjcbfp4zbmbs" />
            </div>
            <div className="space-y-1.5" data-id="element-499" data-mp="377zsnysju94v">
              <Label htmlFor="company-phone" data-id="element-500" data-mp="3792jy7tsadlb">Телефон диспетчерской</Label>
              <Input id="company-phone" value={phone} onChange={e => setPhone(e.target.value)} data-id="element-501" data-mp="3ba4l4u79gzpx" />
            </div>
            <div className="space-y-1.5" data-id="element-502" data-mp="3g7eeum1onxjk">
              <Label htmlFor="city" data-id="element-503" data-mp="3l7982w8xkz7s">Город работы</Label>
              <Select defaultValue="ashgabat" data-id="element-504" data-mp="3l8u46qaw8q7r">
                <SelectTrigger id="city" data-id="element-505" data-mp="3q6c6vyybi97b">
                  <SelectValue data-id="element-506" data-mp="3q5khx6z879q0" />
                </SelectTrigger>
                <SelectContent data-id="element-507" data-mp="3u7p79tin5k6u">
                  <SelectItem value="ashgabat" data-id="element-508" data-mp="3u6mjvvkj1zvo">Ашхабад</SelectItem>
                  <SelectItem value="turkmenabat" data-id="element-509" data-mp="2srmej7pr34g">Туркменабад</SelectItem>
                  <SelectItem value="dashoguz" data-id="element-510" data-mp="2vm80e2gqtzg">Дашогуз</SelectItem>
                  <SelectItem value="mary" data-id="element-511" data-mp="7rute9797jf2">Мары</SelectItem>
                  <SelectItem value="balkanabat" data-id="element-512" data-mp="crz9vz85we5a">Балканабат</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-1.5" data-id="element-513" data-mp="hr22ulavatww">
              <Label htmlFor="commission" data-id="element-514" data-mp="228bciduzw5iz">Комиссия парка, %</Label>
              <Input id="commission" type="number" value={commission} onChange={e => setCommission(e.target.value)} data-id="element-515" data-mp="229w4bvpxdad5" />
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-516" data-mp="1sb6p6apey40l">
          <CardHeader data-id="element-517" data-mp="1sanhdmth8w0a">
            <CardTitle className="text-base" data-id="element-518" data-mp="1sc89l5sbk2uz">Уведомления и автоматизация</CardTitle>
            <CardDescription data-id="element-519" data-mp="1ndex9gorqhwe">Как система общается с водителями и клиентами</CardDescription>
          </CardHeader>
          <CardContent className="divide-y divide-border p-0" data-id="element-520" data-mp="2l0x3ajr1p5wp">
            {toggles.map(t => <div key={t.id} className="flex items-center justify-between gap-4 px-6 py-4" data-id="element-521" data-mp="2g2c5eqz9mybf">
                <div data-id="element-522" data-mp="2b6wqdvpiuwdf">
                  <p className="text-sm font-medium text-foreground" data-id="element-523" data-mp="26ag0ox2oc9y8">{t.label}</p>
                  <p className="text-xs text-muted-foreground" data-id="element-524" data-mp="33pk76yxhjp8p">{t.description}</p>
                </div>
                <button type="button" role="switch" aria-checked={enabled[t.id]} aria-label={t.label} onClick={() => setEnabled(prev => ({
              ...prev,
              [t.id]: !prev[t.id]
            }))} className={cn('relative h-6 w-11 shrink-0 rounded-full transition-colors', enabled[t.id] ? 'bg-primary' : 'bg-border')} data-id="element-525" data-mp="2yyu45scj7yh6">
                  <span className={cn('absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform', enabled[t.id] ? 'translate-x-[22px]' : 'translate-x-0.5')} data-id="element-526" data-mp="2eju0zk6d63p7" />
                </button>
              </div>)}
          </CardContent>
        </Card>

        <div className="flex justify-end gap-2" data-id="element-527" data-mp="2xf0vkkm9vu3b">
          <Button variant="outline" data-id="element-528" data-mp="3l6g08k1iunhq">Отменить</Button>
          <Button onClick={() => toast.success('Настройки сохранены')} data-id="element-529" data-mp="3l4v62vj4d6ke">Сохранить изменения</Button>
        </div>
      </div>
    </div>;
}
export { Settings as SettingsPage };